import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/form-registration.svg';
const _hoisted_1 = {
  class: "card__container"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card__left-side"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "card__picture",
  src: _imports_0,
  alt: "Ilustracja przedstawiająca proces weryfikacji konta"
}), /*#__PURE__*/_createElementVNode("hr", {
  class: "card__break-line"
})], -1);

const _hoisted_3 = {
  class: "card__right-side"
};
const _hoisted_4 = {
  key: 0,
  class: "form"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "form__title"
}, "Rejestracja konta", -1);

const _hoisted_6 = {
  class: "form__steps"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 2
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("Kontynuuj");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("Kontynuuj");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("Zarejestruj");

const _hoisted_13 = {
  class: "form__links"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("Wróć do logowania");

const _hoisted_15 = {
  key: 1,
  class: "form"
};

const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "form__title form__title--big"
}, "Konto aktywowane", -1);

const _hoisted_17 = /*#__PURE__*/_createTextVNode("Przejdź do panelu");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_form_item = _resolveComponent("el-form-item");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_form = _resolveComponent("el-form");

  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [!$setup.formState.isFormDone ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [$setup.formState.step === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Krok 1: wprowadź otrzymany od redakcji klucz aktywacyjny.")) : $setup.formState.step === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Krok 2: wypełnij podstawowe dane konta.")) : $setup.formState.step === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Krok 3: ustaw oraz zatwierdź hasło dla konta.")) : _createCommentVNode("", true)]), $setup.formState.step === 1 ? (_openBlock(), _createBlock(_component_el_form, {
    key: 0,
    ref: "credentialsForm",
    model: $setup.credentials,
    rules: $setup.validationRules,
    onSubmit: _cache[1] || (_cache[1] = _withModifiers($event => $setup.validateCredentials(), ["prevent"]))
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      prop: "activation_key"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.credentials.activation_key,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.credentials.activation_key = $event),
        maxlength: "32",
        placeholder: "Wprowadź klucz aktywacyjny..."
      }, {
        prefix: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          class: "form__input_icon",
          icon: "key"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_button, {
      class: "form__button",
      color: "#32a05a",
      type: "primary",
      "native-type": "submit",
      loading: $setup.componentState.isLoading
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["model", "rules"])) : $setup.formState.step === 2 ? (_openBlock(), _createBlock(_component_el_form, {
    key: 1,
    ref: "credentialsForm",
    model: $setup.credentials,
    rules: $setup.validationRules,
    onSubmit: _cache[4] || (_cache[4] = _withModifiers($event => $setup.validateCredentials(), ["prevent"]))
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      prop: "login"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.credentials.login,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.credentials.login = $event),
        maxlength: "30",
        placeholder: "Wprowadź login..."
      }, {
        prefix: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          class: "form__input_icon",
          icon: "user"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "email"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.credentials.email,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.credentials.email = $event),
        maxlength: "254",
        placeholder: "Wprowadź adres email..."
      }, {
        prefix: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          class: "form__input_icon",
          icon: "envelope"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_button, {
      class: "form__button",
      color: "#32a05a",
      type: "primary",
      "native-type": "submit",
      loading: $setup.componentState.isLoading
    }, {
      default: _withCtx(() => [_hoisted_11]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["model", "rules"])) : $setup.formState.step === 3 ? (_openBlock(), _createBlock(_component_el_form, {
    key: 2,
    ref: "credentialsForm",
    model: $setup.credentials,
    rules: $setup.validationRules,
    onSubmit: _cache[7] || (_cache[7] = _withModifiers($event => $setup.validateCredentials(), ["prevent"]))
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      prop: "password"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.credentials.password,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.credentials.password = $event),
        maxlength: "128",
        placeholder: "Wprowadź hasło...",
        "show-password": ""
      }, {
        prefix: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          class: "form__input_icon",
          icon: "lock"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "password_confirmation"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $setup.credentials.password_confirmation,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.credentials.password_confirmation = $event),
        maxlength: "128",
        placeholder: "Wprowadź ponownie hasło...",
        "show-password": ""
      }, {
        prefix: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          class: "form__input_icon",
          icon: "lock"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_button, {
      class: "form__button",
      color: "#32a05a",
      type: "primary",
      "native-type": "submit",
      loading: $setup.componentState.isLoading
    }, {
      default: _withCtx(() => [_hoisted_12]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["model", "rules"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createVNode(_component_router_link, {
    class: "form__link form__link--secondary",
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_14]),
    _: 1
  })])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_button, {
    class: "form__button",
    type: "success",
    "native-type": "submit",
    loading: $setup.componentState.isLoading,
    onClick: _cache[8] || (_cache[8] = $event => $setup.routerPush('home')),
    plain: ""
  }, {
    default: _withCtx(() => [_hoisted_17]),
    _: 1
  }, 8, ["loading"])]))])]);
}